// extracted by mini-css-extract-plugin
export default {"Booking":"Booking_Booking__t9ay3","links":"Booking_links__w0PgU","bookingDetails":"Booking_bookingDetails__OwnBg"};